import { jsxs, jsx } from 'react/jsx-runtime';
import { IconUpsellTick, IconUpsellCross } from '@fabric-app/icons/old';
import { Flex } from '@fabric-app/ui/components/Flex';
import { P } from '@fabric-app/ui/components/Typography';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { ItemType } from '../../pricing.types.js';
import { styled } from 'styled-components';

const FeatureContainer = styled(Flex).attrs((p) => {
  return {
    alignItems: "center",
    as: "li",
    gap: "element",
    ...p
  };
}).withConfig({
  displayName: "PlanFeatureList__FeatureContainer",
  componentId: "sc-80b2df-0"
})([
  `color:`,
  `;font-size:15px;font-style:normal;font-weight:500;line-height:20px;white-space:nowrap;> svg{flex-shrink:0;width:20px;height:20px;}&[data-has='true']{color:`,
  `;}&[data-feature-type='HIGHLIGHTED']{color:#9e00ff;}&[data-feature-type='BLACK']{color:`,
  `;}`
], cssVar["color-text-tertiary"], cssVar["color-app-primary"], cssVar["color-text-primary"]);
const PlanFeature = ({ feature, textColorSameAsIcon }) => {
  return /* @__PURE__ */ jsxs(FeatureContainer, {
    "data-feature-type": feature.featureType,
    "data-has": feature.has,
    children: [
      feature.has ? /* @__PURE__ */ jsx(IconUpsellTick, {}) : /* @__PURE__ */ jsx(IconUpsellCross, {}),
      /* @__PURE__ */ jsx(P, {
        size: "md",
        color: textColorSameAsIcon ? feature.has ? "app-primary" : "inherit" : "primary",
        weight: 500,
        children: feature.description
      })
    ]
  }, feature.description);
};
const Separator = styled.div.withConfig({
  displayName: "PlanFeatureList__Separator",
  componentId: "sc-80b2df-1"
})([
  `height:1px;align-self:stretch;background:`,
  `;`
], cssVar["color-border-secondary"]);
const PlanFeatureList = ({ items, previousPlanTitle, textColorSameAsIcon }) => {
  return /* @__PURE__ */ jsxs(Container, {
    children: [
      previousPlanTitle && /* @__PURE__ */ jsxs(P, {
        size: "md",
        color: "tertiary",
        weight: 500,
        children: [
          "Everything in ",
          previousPlanTitle,
          ", plus:"
        ]
      }),
      items.map((item, index) => {
        switch (item.type) {
          case ItemType.Feature:
            return /* @__PURE__ */ jsx(PlanFeature, {
              textColorSameAsIcon,
              feature: item
            }, `${index}-${item.description}`);
          case ItemType.Separator:
            return /* @__PURE__ */ jsx(Separator, {}, index);
        }
      })
    ]
  });
};
const Container = styled.div.withConfig({
  displayName: "PlanFeatureList__Container",
  componentId: "sc-80b2df-2"
})([
  `width:100%;column-count:auto;column-width:250px;& > *{margin-bottom:16px;}`
]);

export { FeatureContainer, PlanFeatureList };
//# sourceMappingURL=PlanFeatureList.js.map
